import { FilterValue } from "antd/es/table/interface";

import { ApiUrl } from "../ApiUrl";
import api, { makeQueryParams } from "../ApiService";

export const getResponsiblePersonList = async (
  page: number,
  pageSize: number,
  search: string,
  forDivision: boolean = false,
  companyDivisionId: string = "",
  isReportsToRequired: boolean = true,
  sort: string = "first_name",
  forUserInvite: boolean = false,
  signal?: AbortSignal
) => {
  const response = await api.get(
    `${ApiUrl.usersModule.get_responsible_persons}?page=${page}&page_size=${pageSize}&search=${search}&for_division=${forDivision}&company_division_id=${companyDivisionId}&is_reports_to_required=${isReportsToRequired}&sort_by=${sort}&for_user_invite=${forUserInvite}`,
    { signal }
  );
  return response;
};

export const getUserMenu = async (id: string) => {
  const response = await api.get(
    `${ApiUrl.usersModule.get_users}${id}/list_user_menu_settings/`
  );
  return response;
};

export const hierarchyLevelChange = async (id: string, params: object) => {
  const response = await api.post(
    `${ApiUrl.usersModule.get_users}${id}/hierarchy_level_change/`,
    params
  );
  return response;
};

export const getRoleList = async (companyId: string, obj: {
  page: number,
  pageSize: number,
  search: string
  sort_by: string
}
) => {

  const response = await api.get(
    `${ApiUrl.usersModule.get_roles}${companyId}/list_roles/${makeQueryParams(obj)}`
  );
  return response;
};

export const getDivisionsList = async (
  companyId: string, obj: {
    page: number,
    pageSize: number,
    search: string,
    sort_by: string
  }
) => {
  const response = await api.get(
    `${ApiUrl.usersModule.get_divisions}${companyId}/list_divisions/${makeQueryParams(obj)}`
  );
  return response;
};

export const deleteDivision = async (divisionId: string) => {
  const response = await api.delete(
    `${ApiUrl.usersModule.get_divisions}${divisionId}/`
  );
  return response;
};

export const getFilterDivisionsList = async (
  search: string,
  companyId: string,
  pagination: boolean = true
) => {
  const response = await api.get(
    `${ApiUrl.usersModule.get_divisions}${companyId}/list_divisions/?search=${search}&pagination=${pagination}`
  );
  return response;
};

export const getPersonsByDivision = async (
  divisionId: string,
  page: number,
  pageSize: number,
  search: string = ""
) => {
  const response = await api.get(
    `${ApiUrl.usersModule.get_divisions}${divisionId}/division_users_list/?search=${search}&page=${page}&page_size=${pageSize}`
  );
  return response;
};

export const getUsers = async (
  page: number,
  pageSize: number,
  sortBy: string,
  search: string,
  divisionIds: FilterValue = [],
  isActiveStatusFlag: boolean | null = null,
  loginStatusFlag: boolean | null = null,
  reportingTo: boolean = false
) => {
  const response = await api.get(
    `${ApiUrl.usersModule.get_users}?page=${page}&page_size=${pageSize}&search=${search}&division_id=${divisionIds}&is_active_status_flag=${isActiveStatusFlag}&login_status_flag=${loginStatusFlag}&sort_by=${sortBy}&is_reports_to_required=${reportingTo}`
  );
  return response;
};

export const getShareholders = async (
  companyID: string,
  obj: {
    page: number,
    pageSize: number,
    sort_by: string,
    search: string,
    company_access_flag: boolean | null
  }
) => {
  const response = await api.get(
    `${ApiUrl.shareholder.default}${companyID}/list_shareholders/${makeQueryParams(obj)}`
  );
  return response;
};

export const getReporteeUsers = async (
  page: number,
  pageSize: number,
  search: string,
  sortBy: string,
  divisionIds: FilterValue = [],
  isReportsToRequired: boolean = false
) => {
  const response = await api.get(
    `${ApiUrl.usersModule.get_reporting_users}?page=${page}&page_size=${pageSize}&search=${search}&division_id=${divisionIds}&is_reports_to_required=${isReportsToRequired}&sort_by=${sortBy}`
  );
  return response;
};

export const fetchCompanyLists = async () => {
  const response = await api.get(`${ApiUrl.usersModule.success_manager}`);
  return response;
};

export const fetchShareholderCompanyLists = async () => {
  const response = await api.get(`${ApiUrl.shareholder.companyList}`);
  return response;
};

export const addUser = async (companyId: string, values: object) => {
  const response = await api.post(
    `${ApiUrl.usersModule.add_user}${companyId}/add_user/`,
    values
  );
  return response;
};

export const addUShareholder = async (companyId: string, values: object) => {
  const response = await api.post(
    `${ApiUrl.shareholder.default}${companyId}/invite/`,
    values
  );
  return response;
};

export const updateUser = async (id: string, values: object) => {
  const response = await api.post(
    `${ApiUrl.usersModule.add_user}${id}/update_user_email/`,
    values
  );
  return response;
};

export const updateRole = async (id: string, values: object) => {
  const response = await api.patch(
    `${ApiUrl.usersModule.add_role}${id}/update_role_name/`,
    values
  );
  return response;
};
export const updateDivision = async (
  id: string,
  values: {
    name: string;
    company_division_id: string;
  }
) => {
  const response = await api.patch(
    `${ApiUrl.usersModule.add_division}${id}/update_division_name/`,
    values
  );
  return response;
};

export const addRole = async (companyId: string, values: object) => {
  const response = await api.post(
    `${ApiUrl.usersModule.add_role}${companyId}/create_role/`,
    values
  );
  return response;
};

export const addDivision = async (companyId: string, values: object) => {
  const response = await api.post(
    `${ApiUrl.usersModule.add_division}${companyId}/create_division/`,
    values
  );
  return response;
};

export const updateUserInfo = async (id: string, values: object) => {
  const response = await api.patch(
    `${ApiUrl.usersModule.update_user_status}${id}/update_user_info/`,
    values
  );
  return response;
};

export const updateShareholderCompanyAccess = async (id: string, grantAccess: boolean) => {
  const response = await api.put(
    `${ApiUrl.shareholder.default}${id}/update_company_access/?grant_access=${grantAccess}`
  );
  return response;
};


export const updateUserMenuSettings = async (
  id: string,
  values: object,
  updateType: "order" | "visibility" = "order"
) => {
  const response = await api.patch(
    `${ApiUrl.usersModule.get_users}${id}/update_user_settings/?update_type=${updateType}`,
    values
  );
  return response;
};

export const updateReactiveUser = async (id: string, values: object = {}) => {
  const response = await api.post(
    `${ApiUrl.usersModule.get_users}${id}/reactivate_user/`,
    values
  );
  return response;
};

export const deleteUser = async (id: string) => {
  const response = await api.delete(`${ApiUrl.usersModule.delete_user}${id}/`);
  return response;
};

export const checkSeniorUserExist = async (id: string) => {
  const response = await api.get(
    `${ApiUrl.usersModule.reinvite_user}${id}/check_senior_user_exists/`
  );
  return response;
};

export const reInviteUser = async (id: string) => {
  const response = await api.post(
    `${ApiUrl.usersModule.reinvite_user}${id}/reinvite/`
  );
  return response;
};
